import ButtonGroup from "@/components/ui/molecules/ButtonGroup/ButtonGroup";

type ButtonGroupYesNoWithLabelProps = {
  label: string;
  value: boolean;
  onChange: (value: boolean) => void;
}

const ButtonGroupYesNoWithLabel = ({ label, value, onChange }: ButtonGroupYesNoWithLabelProps) => {
  const options = [
    {label: 'Oui', value: 'true'},
    {label: 'Non', value: 'false'}
  ];

  const optionToBoolean = (option: string): boolean => {
    return option === 'true';
  };

  const booleanToOption = (isActivated: boolean): string => {
    return isActivated ? 'true' : 'false';
  }

  return (
    <div className="flex flex-col gap-2w md:flex-row md:items-center md:justify-between">
      <span className='text-body1'>{label}</span>
      <ButtonGroup className='md:flex-nowrap' options={options} onChange={(value) => onChange(optionToBoolean(value))} value={booleanToOption(value)} />
    </div>
  );
}

export default ButtonGroupYesNoWithLabel;